export class ClipboardManager {
  /**
   * Copy content to clipboard with both HTML and plain text formats
   * - LinkedIn receives optimized plain text
   * - Google Docs/Word receives rich HTML
   */
  static async copyToClipboard(
    htmlContent: string,
    plainTextContent: string
  ): Promise<void> {
    try {
      // Modern Clipboard API
      // We need to construct the ClipboardItem carefully.
      // Some browsers require the Blob to be created immediately.
      
      const items: Record<string, Blob> = {};
      items["text/plain"] = new Blob([plainTextContent], { type: "text/plain" });
      items["text/html"] = new Blob([htmlContent], { type: "text/html" });

      const clipboardItem = new ClipboardItem(items);

      await navigator.clipboard.write([clipboardItem]);
    } catch (error) {
      console.error("Clipboard write failed:", error);
      // Fallback or re-throw
      this.copyToClipboardFallback(htmlContent, plainTextContent);
    }
  }

  /**
   * Fallback method for older browsers
   */
  static copyToClipboardFallback(
    _htmlContent: string,
    plainTextContent: string
  ): void {
    const textArea = document.createElement("textarea");
    textArea.value = plainTextContent;
    
    // Ensure it's not visible but part of DOM
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }
    
    document.body.removeChild(textArea);
  }
}
